<template>
  <v-app>
    <div v-if="isLoading"></div>
    <div v-else>
      <Nav />

      <v-main>
        <router-view />
      </v-main>

      <Footer />
    </div>
  </v-app>
</template>

<script>
import Nav from "@/components/Nav"
import Footer from "@/components/Footer"
import EventBus from "@/EventBus"

import '@/sass/app.scss'

export default {
  data: () => ({
    isLoading: true
  }),
  mounted() {
    let url = window.location.pathname
    let url_parts = url.split('/');
    // console.log(url_parts)
    if  (['en', 'hu', 'uk'].includes(url_parts[1])) {
      // console.log('valid language code')
    } else {
      window.location.href = '/en' + window.location.pathname
    }

    EventBus.$on("i18n-load-start", () => (this.isLoading = true))

    EventBus.$on("i18n-load-complete", () => (this.isLoading = false))
  },
  components: { Nav, Footer }
}
</script>

<style>
</style>
